import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IPaginatedResponse,
  IReceipt,
  IReceiptQueryParams,
} from '@inshuwa-client/models';

export interface IReceiptServices {
  getReceipts(
    param?: Partial<IReceiptQueryParams>,
  ): Observable<IPaginatedResponse<IReceipt>>;
}

export const IReceiptsInjectionToken = new InjectionToken<IReceiptServices>(
  'receiptsServices',
);
